import React from "react";
import { useNavigate } from "react-router-dom";

function KPIComponent({
  iconSVG,
  label,
  info,
  rightIcon = false,
  dropDown = false,
  width,
}) {
  const navigate = useNavigate();
  return (
    <div
      className="d-flex flex-column"
      style={{
        backgroundColor: "#fff",
        padding: "30px 24px",
        borderRadius: "8px",
        width: `${width ? width : "100%"}`,
        height: "173px",
      }}
    >
      <span style={{ marginBottom: "8px" }}>{iconSVG}</span>
      <div className="d-flex" style={{ flexWrap: "wrap" }}>
        <p style={{ marginBottom: "14px", color: "#393F46" }}>{label}</p>
        {dropDown && (
          <span
            style={{
              marginLeft: "10px",
              color: "#393F46",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            60 days{" "}
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 4.379L8.7125 0.666504L9.773 1.727L5 6.5L0.226997 1.727L1.2875 0.666504L5 4.379Z"
                fill="#393F46"
              />
            </svg>
          </span>
        )}
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <p style={{ fontSize: "22px", fontWeight: "600", margin: "0" }}>
          {info}
        </p>
        {rightIcon && (
          <svg
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/scheduled-payments")}
          >
            <path
              d="M5.17198 6.99999L0.221985 2.04999L1.63598 0.635986L7.99998 6.99999L1.63598 13.364L0.221985 11.95L5.17198 6.99999Z"
              fill="#393F46"
            />
          </svg>
        )}
      </div>
    </div>
  );
}

export default KPIComponent;
